import React from 'react';
import { ContextConsumer } from 'shared/components/App';
import { getDisplayName } from '../helpers/common';

export const withFetch = WrappedComponent => {
  const Component = props =>
    <ContextConsumer>
      {({ fetch }) => <WrappedComponent {...props} fetch={fetch} />}
    </ContextConsumer>;
  Component.displayName = `withFetch(${getDisplayName(WrappedComponent)})`;

  return Component;
};



// WEBPACK FOOTER //
// ./src/shared/hocs/withFetch.js